/**
 * A utility function similar to lodash's `get`.
 *
 * @param obj - Object to search for value in
 * @param path - Path of desired value within object
 * @param defaultValue - Default value if path is not found in obj
 * @returns any - A value
 */
export var getWithPath = function (obj, path, defaultValue) {
    if (!obj)
        return defaultValue;
    if (!path.length)
        return obj;
    return getWithPath(obj[path[0]], path.slice(1), defaultValue);
};
